// AUTO-GENERATED by katana-backend/scripts/parse-kling-effects.js
// Source: obsidian_katana-ai/kling-api-docs-2026-04-26/Effects/
// Effects: 270 (15 dual / 255 single)
// Generated: 2026-05-16
// Re-run the script if Kling adds new effects or changes pricing.

export const KLING_EFFECTS = [
  {
    "scene": "3d_cartoon_1_pro",
    "label": "3D Cartoon 1 Pro",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/3d_cartoon_1_pro.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/3d_cartoon_1_pro.mp4"
  },
  {
    "scene": "3d_cartoon_2",
    "label": "3D Cartoon 2",
    "units": 1.2,
    "priceUsd": 0.168,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/3d_cartoon_2-cover.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/3d_cartoon_2.mp4"
  },
  {
    "scene": "a_list_look",
    "label": "A List Look",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/a_list_look.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/a_list_look.mp4"
  },
  {
    "scene": "advent_of_flora",
    "label": "Advent of Flora",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/advent_of_flora.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/advent_of_flora.mp4"
  },
  {
    "scene": "american_comics",
    "label": "American Comics",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/american_comics.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/american_comics.mp4"
  },
  {
    "scene": "angel_wing",
    "label": "Angel Wing",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/angel_wing_new.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/angel_wing.mp4"
  },
  {
    "scene": "anime_figure",
    "label": "Anime Figure",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/anime_figure.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/anime_figure.mp4"
  },
  {
    "scene": "balloon_parade",
    "label": "Balloon Parade",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/balloon_parade.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/balloon_parade.mp4"
  },
  {
    "scene": "baseball",
    "label": "Baseball",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/baseball.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/baseball.mp4"
  },
  {
    "scene": "birthday_star",
    "label": "Birthday Star",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "celebration",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/birthday_star.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/birthday_star.mp4"
  },
  {
    "scene": "black_wings",
    "label": "Black Wing",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/black_wings.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/black_wings.mp4"
  },
  {
    "scene": "bloodline_dance",
    "label": "Bloodline Dance",
    "units": 5.5,
    "priceUsd": 0.77,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/bloodline_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/bloodline_dance.mp4"
  },
  {
    "scene": "bloombloom",
    "label": "Bloom Bloom",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/bloombloom.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/bloombloom.mp4"
  },
  {
    "scene": "boss_coming",
    "label": "Boss Coming",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/boss_coming.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/boss_coming.mp4"
  },
  {
    "scene": "bouncy_dance",
    "label": "Bouncy Dance",
    "units": 4.5,
    "priceUsd": 0.63,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/bouncy_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/bouncy_dance.mp4"
  },
  {
    "scene": "bouquet_drop",
    "label": "Bouquet Drop",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/bouquet_drop.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/bouquet_drop.mp4"
  },
  {
    "scene": "box_of_joy",
    "label": "Box Of Joy",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/box_of_joy.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/box_of_joy.mp4"
  },
  {
    "scene": "brown_bear_hug",
    "label": "Brown bear Hug",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/brown_bear_hug.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/brown_bear_hug.mp4"
  },
  {
    "scene": "building_collapse",
    "label": "Building Collapse",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/building_collapse.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/building_collapse.mp4"
  },
  {
    "scene": "building_sweater",
    "label": "Building Sweater",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/building_sweater.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/building_sweater.mp4"
  },
  {
    "scene": "bullet_time",
    "label": "Bullet Time",
    "units": 7,
    "priceUsd": 0.98,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/bullet_time.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/bullet_time.mp4"
  },
  {
    "scene": "bullet_time_360",
    "label": "Bullet Time 360",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/bullet_time_360.jpg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/bullet_time_360.mp4"
  },
  {
    "scene": "bullet_time_lite",
    "label": "Bullet Time Pro",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/bullet_time_lite.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/bullet_time_lite.mp4"
  },
  {
    "scene": "c4d_cartoon_pro",
    "label": "C4D Cartoon Pro",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/c4d_cartoon_pro.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/c4d_cartoon_pro.mp4"
  },
  {
    "scene": "car_explosion",
    "label": "Car Explosion",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/car_explosion.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/car_explosion.mp4"
  },
  {
    "scene": "chanel_dance",
    "label": "Chanel Dance",
    "units": 4.5,
    "priceUsd": 0.63,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/chanel_dance.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/chanel_dance.mp4"
  },
  {
    "scene": "cheers_2026",
    "label": "Cheers 2026",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/cheers_2026.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/cheers_2026.mp4"
  },
  {
    "scene": "chinese_trend",
    "label": "Chinese Trend",
    "units": 7.5,
    "priceUsd": 1.05,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/chinese_trend.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/chinese_trend.mp4"
  },
  {
    "scene": "christmas_photo_shoot",
    "label": "Christmas Photo Shoot",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/christmas_photo_shoot.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/christmas_photo_shoot.mp4"
  },
  {
    "scene": "city_to_village",
    "label": "City To Village",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/city_to_village.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/city_to_village.mp4"
  },
  {
    "scene": "color_mixing",
    "label": "Color Mixing",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/color_mixing.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/color_mixing.mp4"
  },
  {
    "scene": "construction_worker",
    "label": "Construction Worker",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/construction_worker.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/construction_worker.mp4"
  },
  {
    "scene": "coronation_of_frost",
    "label": "Coronation of Frost",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/coronation_of_frost.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/coronation_of_frost.mp4"
  },
  {
    "scene": "countdown_teleport",
    "label": "Countdown Teleport",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "celebration",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/countdown_teleport.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/countdown_teleport.mp4"
  },
  {
    "scene": "cozy_toon_wrap",
    "label": "Cozy Toon Wrap",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/cozy_toon_wrap.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/cozy_toon_wrap.mp4"
  },
  {
    "scene": "cry_cry",
    "label": "Cry Cry",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/cry_cry.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/cry_cry.mp4"
  },
  {
    "scene": "crystal_horse",
    "label": "Crystal Horse",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/crystal_horse.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/crystal_horse.mp4"
  },
  {
    "scene": "cute_dance",
    "label": "Cute Dance",
    "units": 6,
    "priceUsd": 0.84,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/cute_dance.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/cute_dance.mp4"
  },
  {
    "scene": "cute_ghost_transform",
    "label": "Cute Ghost Transform",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/cute_ghost_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/cute_ghost_transform.mp4"
  },
  {
    "scene": "cute_pumpkin_transform",
    "label": "Cute Pumpkin Transform",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/cute_pumpkin_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/cute_pumpkin_transform.mp4"
  },
  {
    "scene": "daily_ootd",
    "label": "Daily OOTD",
    "units": 4,
    "priceUsd": 0.56,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/daily_oot.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/daily_ootd.mp4"
  },
  {
    "scene": "dance_with_dragon",
    "label": "Dance With Dragon",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/dance_with_dragon_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dance_with_dragon.mp4"
  },
  {
    "scene": "daoma_dance",
    "label": "Daoma Dance",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/daoma_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/daoma_dance.mp4"
  },
  {
    "scene": "dark_wing",
    "label": "Dark Wing",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/dark_wing.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dark_wing.mp4"
  },
  {
    "scene": "day_to_night",
    "label": "Day To Night",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/day_to_night.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/day_to_night.mp4"
  },
  {
    "scene": "demon_transform",
    "label": "Demon Transform",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/demon_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/demon_transform.mp4"
  },
  {
    "scene": "dirt_rush",
    "label": "Dirt Rush",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/dirt_rush_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dirt_rush.mp4"
  },
  {
    "scene": "disappear",
    "label": "Disappear",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/disappear-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/disappear.mp4"
  },
  {
    "scene": "dishwasher",
    "label": "Dishwasher",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic/dishwasher.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dishwasher.mp4"
  },
  {
    "scene": "dizzydizzy",
    "label": "Dizzy Dizzy",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/dizzydizzy.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dizzydizzy.mp4"
  },
  {
    "scene": "dollar_rain",
    "label": "Dollar Rain",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/dollar_rain.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dollar_rain.mp4"
  },
  {
    "scene": "dollar_rain_pro",
    "label": "Dollar Rain Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/dollar_rain_pro.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dollar_rain_pro.mp4"
  },
  {
    "scene": "double_gun",
    "label": "Double Gun",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/double_gun.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/double_gun.mp4"
  },
  {
    "scene": "drunk_dance",
    "label": "Drunk Dance",
    "units": 7,
    "priceUsd": 0.98,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/drunk_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/drunk_dance.mp4"
  },
  {
    "scene": "drunk_dance_pet",
    "label": "Drunk Dance Pet",
    "units": 7,
    "priceUsd": 0.98,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/drunk_dance_pet.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/drunk_dance_pet.mp4"
  },
  {
    "scene": "dumpling_making_pet",
    "label": "Dumpling Making Pet",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/dumpling_making_pet.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/dumpling_making_pet.mp4"
  },
  {
    "scene": "eagle_snatch",
    "label": "Eagle Snatch",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/eagle_snatch_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/eagle_snatch.mp4"
  },
  {
    "scene": "emoji",
    "label": "Emoji",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/emoji-new.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/emoji.mp4"
  },
  {
    "scene": "eternal_kiss",
    "label": "Eternal Kiss",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/eternal_kiss.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/eternal_kiss.mp4"
  },
  {
    "scene": "expansion",
    "label": "Expansion",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/expansion.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/expansion.mp4"
  },
  {
    "scene": "expression_challenge",
    "label": "Expression Challenge",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/expression_challenge.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/expression_challenge.mp4"
  },
  {
    "scene": "f1_live",
    "label": "F1 Live",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/f1_live-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/f1_live.mp4"
  },
  {
    "scene": "fairy_wing",
    "label": "Fairy Wing",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/fairy_wing.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fairy_wing.mp4"
  },
  {
    "scene": "feed_mooncake",
    "label": "Feed Mooncake",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic/feed_mooncake-4.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/feed_mooncake.mp4"
  },
  {
    "scene": "felt_felt",
    "label": "Felt Felt",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_raw_pic_compress/felt_felt.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/felt_felt.mp4"
  },
  {
    "scene": "fight_pro",
    "label": "Fight Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/fight_pro.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fight_pro.mp4"
  },
  {
    "scene": "finger_swipe",
    "label": "Finger Swipe",
    "units": 3,
    "priceUsd": 0.42,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/finger_swipe.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/finger_swipe.mp4"
  },
  {
    "scene": "firework",
    "label": "Firework",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/firework.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/firework.mp4"
  },
  {
    "scene": "firework_2026",
    "label": "2026 Ignite",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/firework_2026.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/firework_2026.mp4"
  },
  {
    "scene": "first_toast_of_the_year",
    "label": "First Toast Of The Year",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "celebration",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/first_toast_of_the_year.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/first_toast_of_the_year.mp4"
  },
  {
    "scene": "fish_making_pet",
    "label": "Fish Making Pet",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/fish_making_pet.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fish_making_pet.mp4"
  },
  {
    "scene": "flash_drive",
    "label": "Flash Drive",
    "units": 8.5,
    "priceUsd": 1.19,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/flash_drive-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/flash_drive.mp4"
  },
  {
    "scene": "flash_ride",
    "label": "Flash Ride",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/flash_ride_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/flash_ride.mp4"
  },
  {
    "scene": "fly_fly",
    "label": "Fly Fly",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/fly_fly.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fly_fly.mp4"
  },
  {
    "scene": "flyer",
    "label": "flyer",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic/flyer.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/flyer.mp4"
  },
  {
    "scene": "football_live",
    "label": "Football Live",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/football_live.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/football_live.mp4"
  },
  {
    "scene": "fortune_god_transform",
    "label": "Fortune God Transform",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/fortune_god_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fortune_god_transform.mp4"
  },
  {
    "scene": "fortune_in_motion",
    "label": "Fortune In Motion",
    "units": 7,
    "priceUsd": 0.98,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/fortune_in_motion.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fortune_in_motion.mp4"
  },
  {
    "scene": "fortune_knocks_cartoon",
    "label": "Fortune Knocks Cartoon",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/fortune_knocks_cartoon.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fortune_knocks_cartoon.mp4"
  },
  {
    "scene": "french_elegance",
    "label": "French Elegance",
    "units": 9,
    "priceUsd": 1.26,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/french_elegance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/french_elegance.mp4"
  },
  {
    "scene": "funky_martian",
    "label": "Funky Martian",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/funky_martian_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/funky_martian.mp4"
  },
  {
    "scene": "fuzzyfuzzy",
    "label": "Fuzzy Fuzzy",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/fuzzyfuzzy.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/fuzzyfuzzy.mp4"
  },
  {
    "scene": "gallery_ring",
    "label": "Gallery Ring",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/gallery_ring-cover.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/gallery_ring.mp4"
  },
  {
    "scene": "get_rich_quick",
    "label": "Get Rich Quick",
    "units": 8.5,
    "priceUsd": 1.19,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/get_rich_quick_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/get_rich_quick.mp4"
  },
  {
    "scene": "ghost_step_dance",
    "label": "Ghost Step Dance",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/ghost_step_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/ghost_step_dance.mp4"
  },
  {
    "scene": "glamour_photo_shoot",
    "label": "Glamour Photo Shoot",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/glamour_photo_shoot.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/glamour_photo_shoot.mp4"
  },
  {
    "scene": "golden_horse_fortune",
    "label": "Golden Horse Fortune",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/golden_horse_fortune.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/golden_horse_fortune.mp4"
  },
  {
    "scene": "golden_wing",
    "label": "Golden Wing",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/golden_wing.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/golden_wing.mp4"
  },
  {
    "scene": "good_luck_dance",
    "label": "Good Luck Dance",
    "units": 6.5,
    "priceUsd": 0.91,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/good_luck_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/good_luck_dance.mp4"
  },
  {
    "scene": "good_luck_spirit",
    "label": "Good Luck Spirit",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/good_luck_spirit_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/good_luck_spirit.mp4"
  },
  {
    "scene": "great_success",
    "label": "Great Success",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/great_success.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/great_success.mp4"
  },
  {
    "scene": "guardian_spirit",
    "label": "Guardian Spirit",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/guardian_spirit.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/guardian_spirit.mp4"
  },
  {
    "scene": "guess_what",
    "label": "Guess What",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/guess_what.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/guess_what.mp4"
  },
  {
    "scene": "gun_shot",
    "label": "Gun Shot",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/gun_shot.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/gun_shot.mp4"
  },
  {
    "scene": "halloween_escape",
    "label": "Halloween Escape",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/halloween_escape.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/halloween_escape.mp4"
  },
  {
    "scene": "happy_birthday",
    "label": "Cake Delivery",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "celebration",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/happy_birthday.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/happy_birthday.mp4"
  },
  {
    "scene": "heart_gesture_1",
    "label": "Heart Gesture 1",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/heart_gesture_1.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/heart_gesture_1.mp4"
  },
  {
    "scene": "heart_gesture_dance",
    "label": "Heart Gesture Dance",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/heart_gesture_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/heart_gesture_dance.mp4"
  },
  {
    "scene": "heart_gesture_pro",
    "label": "Heart Gesture Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/heart_gesture_pro.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/heart_gesture_pro.mp4"
  },
  {
    "scene": "horse_mask",
    "label": "Horse Mask",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/horse_mask.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/horse_mask.mp4"
  },
  {
    "scene": "horse_year_firework",
    "label": "Horse Year Firework",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/horse_year_firework.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/horse_year_firework.mp4"
  },
  {
    "scene": "hot_feet_dance",
    "label": "Hot Feet Dance",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/hot_feet_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/hot_feet_dance.mp4"
  },
  {
    "scene": "hug_from_past",
    "label": "Hug From Past",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/hug_from_past_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/hug_from_past.mp4"
  },
  {
    "scene": "hug_pro",
    "label": "Hug Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/hug_pro.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/hug_pro.mp4"
  },
  {
    "scene": "inner_voice",
    "label": "Inner Voice",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/inner_voice.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/inner_voice.mp4"
  },
  {
    "scene": "instant_christmas",
    "label": "Instant Christmas",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/instant_christmas.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/instant_christmas.mp4"
  },
  {
    "scene": "instant_film",
    "label": "Instant Film",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/instant_film.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/instant_film.mp4"
  },
  {
    "scene": "instant_kid",
    "label": "Instant Kid",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/instant_kid.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/instant_kid.mp4"
  },
  {
    "scene": "japanese_anime_1",
    "label": "Japanese Anime 1",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/japanese_anime_1.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/japanese_anime_1.mp4"
  },
  {
    "scene": "jazz_jazz",
    "label": "Jazz Jazz",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/jazz_jazz.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jazz_jazz.mp4"
  },
  {
    "scene": "jelly_jiggle",
    "label": "Jelly Jiggle",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/jelly_jiggle_new.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jelly_jiggle.mp4"
  },
  {
    "scene": "jelly_press",
    "label": "Jelly Press",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/jelly_press.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jelly_press.mp4"
  },
  {
    "scene": "jelly_slice",
    "label": "Jelly Slice",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/jelly_slice_cover_new.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jelly_slice.mp4"
  },
  {
    "scene": "jelly_squish",
    "label": "Jelly Squish",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/jelly_squish.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jelly_squish.mp4"
  },
  {
    "scene": "jesus_hug",
    "label": "Jesus Hug",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/jesus_hug.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jesus_hug.mp4"
  },
  {
    "scene": "jumpdrop",
    "label": "Jump Drop",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_raw_pic_compress/jumpdrop.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jumpdrop.mp4"
  },
  {
    "scene": "jumping_ginger_joy",
    "label": "Jumping Ginger Joy",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/jumping_ginger_joy.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/jumping_ginger_joy.mp4"
  },
  {
    "scene": "kiss_pro",
    "label": "Kiss Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/kiss_pro.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/kiss_pro.mp4"
  },
  {
    "scene": "knock_at_a_door_revenge",
    "label": "Knock At A Door Revenge",
    "units": 6,
    "priceUsd": 0.84,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/knock_at_a_door_revenge.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/knock_at_a_door_revenge.mp4"
  },
  {
    "scene": "knock_knock_halloween",
    "label": "Knock Knock Halloween",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/knock_knock_halloween.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/knock_knock_halloween.mp4"
  },
  {
    "scene": "korean_baseball",
    "label": "Korean Baseball",
    "units": 8,
    "priceUsd": 1.12,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/korean_baseball-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/korean_baseball.mp4"
  },
  {
    "scene": "korean_baseball_9_16",
    "label": "Korean Baseball 9_16",
    "units": 8,
    "priceUsd": 1.12,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/korean_baseball_9_16.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/korean_baseball_9_16.mp4"
  },
  {
    "scene": "laicai_dance",
    "label": "Laicai Dance",
    "units": 6.5,
    "priceUsd": 0.91,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/laicai_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/laicai_dance.mp4"
  },
  {
    "scene": "landmark_reveal",
    "label": "Landmark Reveal",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/landmark_reveal.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/landmark_reveal.mp4"
  },
  {
    "scene": "lantern_festival_cuju",
    "label": "Lantern Festival Cuju",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lantern_festival_cuju.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lantern_festival_cuju.mp4"
  },
  {
    "scene": "lantern_glow",
    "label": "Lantern Glow",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lantern_glow.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lantern_glow.mp4"
  },
  {
    "scene": "lateral_shift_transition",
    "label": "Lateral Shift Transition",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lateral_shift_transition.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lateral_shift_transition.mp4"
  },
  {
    "scene": "let's_ride",
    "label": "Let's ride",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/lets_ride_new.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/let's_ride.mp4"
  },
  {
    "scene": "lie_flat",
    "label": "Lie flat",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/lie_flat.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lie_flat.mp4"
  },
  {
    "scene": "lightning_power",
    "label": "Lightning Power",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/lightning_power.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lightning_power.mp4"
  },
  {
    "scene": "lion_dance",
    "label": "Lion Dance",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lion_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lion_dance.mp4"
  },
  {
    "scene": "lion_dance_pet",
    "label": "Lion Dance Pet",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lion_dance_pet.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lion_dance_pet.mp4"
  },
  {
    "scene": "long_hair",
    "label": "Long Hair",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/long_hair.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/long_hair.mp4"
  },
  {
    "scene": "love_theme_song",
    "label": "Love Theme Song",
    "units": 5.5,
    "priceUsd": 0.77,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/love_theme_song.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/love_theme_song.mp4"
  },
  {
    "scene": "lucky_horse_year",
    "label": "Lucky Horse Year",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lucky_horse_year.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lucky_horse_year.mp4"
  },
  {
    "scene": "lucky_money_come",
    "label": "Lucky Money Come",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lucky_money_come.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lucky_money_come.mp4"
  },
  {
    "scene": "lucky_red_packet",
    "label": "Lucky Red Packet",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lucky_red_packet.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lucky_red_packet.mp4"
  },
  {
    "scene": "lucky_veggie",
    "label": "Lucky Veggie",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/lucky_veggie_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/lucky_veggie.mp4"
  },
  {
    "scene": "luminous_elf",
    "label": "Luminous Elf",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/luminous_elf.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/luminous_elf.mp4"
  },
  {
    "scene": "maestro_of_magic",
    "label": "Maestro Of Magic",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/maestro_of_magic_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/maestro_of_magic.mp4"
  },
  {
    "scene": "magic_broom",
    "label": "Magic Broom",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_raw_pic_compress/magic_broom.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/magic_broom.mp4"
  },
  {
    "scene": "magic_carpet_ride",
    "label": "Magic Carpet Ride",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/magic_carpet_ride_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/magic_carpet_ride.mp4"
  },
  {
    "scene": "magic_cloak",
    "label": "Magic Cloak",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/magic_cloak.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/magic_cloak.mp4"
  },
  {
    "scene": "magic_fireball",
    "label": "Magic Fireball",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/magic_fireball.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/magic_fireball.mp4"
  },
  {
    "scene": "magic_match_tree",
    "label": "Magic Match Tree",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/magic_match_tree.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/magic_match_tree.mp4"
  },
  {
    "scene": "make_it_rain",
    "label": "Make It Rain",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/make_it_rain_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/make_it_rain.mp4"
  },
  {
    "scene": "marry_me",
    "label": "Marry Me",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/marry_me.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/marry_me.mp4"
  },
  {
    "scene": "martial_arts",
    "label": "Martial Arts",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/martial_arts.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/martial_arts.mp4"
  },
  {
    "scene": "martial_meow",
    "label": "Martial Meow",
    "units": 8,
    "priceUsd": 1.12,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/martial_meow_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/martial_meow.mp4"
  },
  {
    "scene": "media_interview",
    "label": "Media Interview",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/media_interview.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/media_interview.mp4"
  },
  {
    "scene": "memory_alive",
    "label": "Memory Alive",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/memory_alive.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/memory_alive.mp4"
  },
  {
    "scene": "minimalist_light",
    "label": "Minimalist Light",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/minimalist_light_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/minimalist_light.mp4"
  },
  {
    "scene": "motorcycle_dance",
    "label": "Motorcycle Dance",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/motorcycle_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/motorcycle_dance.mp4"
  },
  {
    "scene": "mummy_transform",
    "label": "Mummy Transform",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/mummy_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/mummy_transform.mp4"
  },
  {
    "scene": "muscle_pet",
    "label": "Muscle Pet",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/muscle_pet_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/muscle_pet.mp4"
  },
  {
    "scene": "mushroom",
    "label": "Mushroom",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/mushroom.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/mushroom.mp4"
  },
  {
    "scene": "my_santa_pic",
    "label": "My Santa Pic",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/my_santa_pic.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/my_santa_pic.mp4"
  },
  {
    "scene": "mythic_style",
    "label": "Mythic Style",
    "units": 1.2,
    "priceUsd": 0.168,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/mythic_style-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/mythic_style.mp4"
  },
  {
    "scene": "new_year_feast",
    "label": "New Year Feast",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/new_year_feast.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/new_year_feast.mp4"
  },
  {
    "scene": "new_year_greeting",
    "label": "New Year Greeting",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/new_year_greeting.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/new_year_greeting.mp4"
  },
  {
    "scene": "nezha",
    "label": "Nezha",
    "units": 4.5,
    "priceUsd": 0.63,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/nezha.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/nezha.mp4"
  },
  {
    "scene": "office_escape_plow",
    "label": "Office Escape Plow",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/office_escape_plow.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/office_escape_plow.mp4"
  },
  {
    "scene": "ornament_crash",
    "label": "Ornament Crash",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/ornament_crash.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/ornament_crash.mp4"
  },
  {
    "scene": "overdrive",
    "label": "OverDrive",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/overdrive.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/overdrive.mp4"
  },
  {
    "scene": "palm_sized_figure",
    "label": "Palm Sized Figure",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/palm_sized_figure.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/palm_sized_figure.mp4"
  },
  {
    "scene": "palm_sized_figure_pro",
    "label": "Palm Sized Figure Pro",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/palm_sized_figure_pro.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/palm_sized_figure_pro.mp4"
  },
  {
    "scene": "particle_santa_surround",
    "label": "Particle Santa Surround",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/particle_santa_surround.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/particle_santa_surround.mp4"
  },
  {
    "scene": "perler_beads",
    "label": "Perler Beads",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/perler_beads.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/perler_beads.mp4"
  },
  {
    "scene": "pet_bee",
    "label": "Pet Bee",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pet_bee.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_bee.mp4"
  },
  {
    "scene": "pet_bee_pro",
    "label": "Pet Bee Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/pet_bee_pro.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_bee_pro.mp4"
  },
  {
    "scene": "pet_chef",
    "label": "Pet Chef",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pet_chef.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_chef.mp4"
  },
  {
    "scene": "pet_chinese_opera",
    "label": "Pet Chinese Opera",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/pet_chinese_opera.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_chinese_opera.mp4"
  },
  {
    "scene": "pet_dance",
    "label": "Pet Dance",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pet_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_dance.mp4"
  },
  {
    "scene": "pet_delivery",
    "label": "Pet Delivery",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pet_delivery.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_delivery.mp4"
  },
  {
    "scene": "pet_lion_pro",
    "label": "Pet Lion Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/pet_lion_pro.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_lion_pro.mp4"
  },
  {
    "scene": "pet_moto_rider",
    "label": "Pet Moto Rider",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pet_moto_rider.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_moto_rider.mp4"
  },
  {
    "scene": "pet_red_packet",
    "label": "Pet Red Packet",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/pet_red_packet.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_red_packet.mp4"
  },
  {
    "scene": "pet_skateboard",
    "label": "Pet Skateboard",
    "units": 4,
    "priceUsd": 0.56,
    "type": "dual",
    "category": "pet",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/pet_skateboard.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_skateboard.mp4"
  },
  {
    "scene": "pet_vlogger",
    "label": "Pet Vlogger",
    "units": 6,
    "priceUsd": 0.84,
    "type": "single",
    "category": "pet",
    "coverUrl": null,
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_vlogger.mp4"
  },
  {
    "scene": "pet_warrior",
    "label": "Pet Warrior",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pet_warrior.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_warrior.mp4"
  },
  {
    "scene": "pet_wizard",
    "label": "Pet Wizard",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "pet",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pet_wizard.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pet_wizard.mp4"
  },
  {
    "scene": "phantom_jewel",
    "label": "Phantom Jewel",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/phantom_jewel.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/phantom_jewel.mp4"
  },
  {
    "scene": "pigeon_dance",
    "label": "Pigeon Dance",
    "units": 5.5,
    "priceUsd": 0.77,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/pigeon_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pigeon_dance.mp4"
  },
  {
    "scene": "piggy_morph",
    "label": "Piggy Morph",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/piggy_morph.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/piggy_morph.mp4"
  },
  {
    "scene": "pink_pink_wings",
    "label": "Pink Wing",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/pink_pink_wings.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pink_pink_wings.mp4"
  },
  {
    "scene": "pixelpixel",
    "label": "Pixel Pixel",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/pixelpixel.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pixelpixel.mp4"
  },
  {
    "scene": "plushcut",
    "label": "Plush Cut",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/plushcut-new.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/plushcut.mp4"
  },
  {
    "scene": "polar_bear_hug",
    "label": "Polar Bear Hug",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/polar_bear_hug.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/polar_bear_hug.mp4"
  },
  {
    "scene": "poping",
    "label": "Poping",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/poping.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/poping.mp4"
  },
  {
    "scene": "prank_box",
    "label": "Prank Box",
    "units": 4.5,
    "priceUsd": 0.63,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/prank_box.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/prank_box.mp4"
  },
  {
    "scene": "prosperity",
    "label": "Prosperity",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/prosperity.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/prosperity.mp4"
  },
  {
    "scene": "pucker_up",
    "label": "Pucker Up",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/pucker_up.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pucker_up.mp4"
  },
  {
    "scene": "pumpitup_dance",
    "label": "Pumpitup Dance",
    "units": 5.5,
    "priceUsd": 0.77,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/pumpitup_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pumpitup_dance.mp4"
  },
  {
    "scene": "pumpkin_head_transform",
    "label": "Pumpkin Head Transform",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/pumpkin_head_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pumpkin_head_transform.mp4"
  },
  {
    "scene": "pure_white_wings",
    "label": "Pure White Wing",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/pure_white_wings.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/pure_white_wings.mp4"
  },
  {
    "scene": "raid_check",
    "label": "Raid Check",
    "units": 4.5,
    "priceUsd": 0.63,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/raid_check.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/raid_check.mp4"
  },
  {
    "scene": "rampage_ape",
    "label": "Rampage Ape",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/rampage_ape.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/rampage_ape.mp4"
  },
  {
    "scene": "red_packet_box",
    "label": "Red Packet Unboxing",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/red_packet_box.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/red_packet_box.mp4"
  },
  {
    "scene": "return_of_the_king",
    "label": "Return Of The King",
    "units": 2.7,
    "priceUsd": 0.378,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/return_of_the_king_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/return_of_the_king.mp4"
  },
  {
    "scene": "ring_in_new",
    "label": "Ring In New",
    "units": 1.6,
    "priceUsd": 0.224,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/ring_in_new.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/ring_in_new.mp4"
  },
  {
    "scene": "rocketrocket",
    "label": "Rocket Rocket",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/rocketrocket.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/rocketrocket.mp4"
  },
  {
    "scene": "running",
    "label": "Running",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/running.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/running.mp4"
  },
  {
    "scene": "running_man",
    "label": "Running Man",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/running_man-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/running_man.mp4"
  },
  {
    "scene": "santa_express",
    "label": "Santa Express",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/santa_express.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/santa_express.mp4"
  },
  {
    "scene": "santa_gift",
    "label": "Santa Gift",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/santa_gift.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/santa_gift.mp4"
  },
  {
    "scene": "santa_gifts",
    "label": "Santa Gifts",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/santa_gifts.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/santa_gifts.mp4"
  },
  {
    "scene": "santa_hug",
    "label": "Santa Hug",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/santa_hug.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/santa_hug.mp4"
  },
  {
    "scene": "santa_random_surprise",
    "label": "Elf's Playful Spell",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/santa_random_surprise.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/santa_random_surprise.mp4"
  },
  {
    "scene": "sassy_shake",
    "label": "Sassy Shake",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/sassy_shake_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/sassy_shake.mp4"
  },
  {
    "scene": "scarlet_and_snow",
    "label": "Scarlet And Snow",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/scarlet_and_snow.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/scarlet_and_snow.mp4"
  },
  {
    "scene": "sedan_chair_dance",
    "label": "Sedan Chair Dance",
    "units": 7,
    "priceUsd": 0.98,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/sedan_chair_dance_2.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/sedan_chair_dance.mp4"
  },
  {
    "scene": "send_my_love",
    "label": "Send My Love!",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/send_my_love_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/send_my_love.mp4"
  },
  {
    "scene": "shark_alert",
    "label": "Shark Alert",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/shark_alert.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/shark_alert.mp4"
  },
  {
    "scene": "shooting_star",
    "label": "Shooting Star",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/shooting_star_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/shooting_star.mp4"
  },
  {
    "scene": "shush_my_dreams",
    "label": "Shush! My Dreams",
    "units": 4.5,
    "priceUsd": 0.63,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/shush_my_dreams.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/shush_my_dreams.mp4"
  },
  {
    "scene": "siblings",
    "label": "Siblings",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/siblings.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/siblings.mp4"
  },
  {
    "scene": "skateskate",
    "label": "Skate Skate",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/skateskate.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/skateskate.mp4"
  },
  {
    "scene": "ski_ski",
    "label": "Ski Ski",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/ski_ski.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/ski_ski.mp4"
  },
  {
    "scene": "skyfall",
    "label": "Skyfall",
    "units": 7.7,
    "priceUsd": 1.078,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/skyfall.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/skyfall.mp4"
  },
  {
    "scene": "smoke_smoke",
    "label": "Smoke Smoke",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/smoke_smoke.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/smoke_smoke.mp4"
  },
  {
    "scene": "smooth_sailing_dance",
    "label": "Smooth Sailing Dance",
    "units": 7,
    "priceUsd": 0.98,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/smooth_sailing_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/smooth_sailing_dance.mp4"
  },
  {
    "scene": "smooth_transition",
    "label": "Smooth Transition",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/smooth_transition.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/smooth_transition.mp4"
  },
  {
    "scene": "snatched",
    "label": "Snatched",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/snatched_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/snatched.mp4"
  },
  {
    "scene": "snow_night_kiss",
    "label": "Snow Night Kiss",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "dual",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/snow_night_kiss.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/snow_night_kiss.mp4"
  },
  {
    "scene": "snowboarding",
    "label": "Snowboarding",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/snowboarding.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/snowboarding.mp4"
  },
  {
    "scene": "snowglobe",
    "label": "Snowglobe",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/snowglobe.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/snowglobe.mp4"
  },
  {
    "scene": "sovereign_scepter",
    "label": "Sovereign Scepter",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/sovereign_scepter_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/sovereign_scepter.mp4"
  },
  {
    "scene": "spark_in_the_snow",
    "label": "Spark In The Snow",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/spark_in_the_snow.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/spark_in_the_snow.mp4"
  },
  {
    "scene": "sparkler_wand",
    "label": "Sparkler Wand",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/sparkler_wand_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/sparkler_wand.mp4"
  },
  {
    "scene": "spielberg_transition",
    "label": "Spielberg Transition",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/spielberg_transition.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/spielberg_transition.mp4"
  },
  {
    "scene": "spring_bloom",
    "label": "Spring Bloom",
    "units": 4,
    "priceUsd": 0.56,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/spring_bloom.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/spring_bloom.mp4"
  },
  {
    "scene": "squeeze_scream",
    "label": "Squeeze Scream",
    "units": 1.2,
    "priceUsd": 0.168,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/squeeze_scream-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/squeeze_scream.mp4"
  },
  {
    "scene": "squish",
    "label": "Squish",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/squish.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/squish.mp4"
  },
  {
    "scene": "steampunk",
    "label": "Steampunk",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/steampunk-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/steampunk.mp4"
  },
  {
    "scene": "steampunk_christmas",
    "label": "Steampunk Christmas",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/steampunk_christmas.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/steampunk_christmas.mp4"
  },
  {
    "scene": "studio_look",
    "label": "Studio Look",
    "units": 8,
    "priceUsd": 1.12,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/studio_look.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/studio_look.mp4"
  },
  {
    "scene": "subject_3_dance",
    "label": "Subject 3 Dance",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/subject_3_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/subject_3_dance.mp4"
  },
  {
    "scene": "surfsurf",
    "label": "Surf Surf",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/surfsurf.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/surfsurf.mp4"
  },
  {
    "scene": "surprise_bouquet",
    "label": "Surprise Bouquet",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/surprise_bouquet.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/surprise_bouquet.mp4"
  },
  {
    "scene": "swag_dance",
    "label": "Swag Dance",
    "units": 5.5,
    "priceUsd": 0.77,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/swag_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/swag_dance.mp4"
  },
  {
    "scene": "swing_swing",
    "label": "Swing Swing",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/swing_swing.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/swing_swing.mp4"
  },
  {
    "scene": "swish_swish",
    "label": "Swish Swish",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/swish_swish.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/swish_swish.mp4"
  },
  {
    "scene": "switch_to_silk",
    "label": "Switch To Silk",
    "units": 5.5,
    "priceUsd": 0.77,
    "type": "dual",
    "category": "halloween",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/switch_to_silk_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/switch_to_silk.mp4"
  },
  {
    "scene": "tangyuan_to_animal",
    "label": "Tangyuan To Animal",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/tangyuan_to_animal.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/tangyuan_to_animal.mp4"
  },
  {
    "scene": "the_exercise",
    "label": "The Exercise",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/the_exercise._cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/the_exercise.mp4"
  },
  {
    "scene": "the_high_kick",
    "label": "The High Kick",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/the_high_kick_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/the_high_kick.mp4"
  },
  {
    "scene": "the_hip_sway",
    "label": "The Hip Sway",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "dance",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/the_hip_sway._cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/the_hip_sway.mp4"
  },
  {
    "scene": "throne_of_king",
    "label": "Throne of King",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/throne_of_king.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/throne_of_king.mp4"
  },
  {
    "scene": "thumbs_up_pro",
    "label": "Thumbs Up Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/thumbs_up_pro.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/thumbs_up_pro.mp4"
  },
  {
    "scene": "tiger_hug_pro",
    "label": "Tiger Hug Pro",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "duo_social",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/tiger_hug_pro.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/tiger_hug_pro.mp4"
  },
  {
    "scene": "tiny_beast_printer",
    "label": "Tiny Beast Printer",
    "units": 4.5,
    "priceUsd": 0.63,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/tiny_beast_printer-cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/tiny_beast_printer.mp4"
  },
  {
    "scene": "toss_run",
    "label": "Toss & Run",
    "units": 6,
    "priceUsd": 0.84,
    "type": "dual",
    "category": "duo_social",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/toss_run_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/toss_run.mp4"
  },
  {
    "scene": "trampoline",
    "label": "Trampoline",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/trampoline.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/trampoline.mp4"
  },
  {
    "scene": "trampoline_night",
    "label": "Trampoline Night",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "sports",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/trampoline_night.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/trampoline_night.mp4"
  },
  {
    "scene": "twist_shake",
    "label": "Twist Shake",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/twist_shake_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/twist_shake.mp4"
  },
  {
    "scene": "unique_firework",
    "label": "Unique Firework",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/unique_firework.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/unique_firework.mp4"
  },
  {
    "scene": "unique_spring_couplets",
    "label": "Unique Spring Couplets",
    "units": 2.5,
    "priceUsd": 0.35,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/unique_spring_couplets.jpeg",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/unique_spring_couplets.mp4"
  },
  {
    "scene": "vampire_transform",
    "label": "Vampire Transform",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/vampire_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/vampire_transform.mp4"
  },
  {
    "scene": "venomous_spider",
    "label": "Venomous Spider",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/venomous_spider.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/venomous_spider.mp4"
  },
  {
    "scene": "watermelon_bomb",
    "label": "Watermelon Bomb",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "other",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/watermelon_bomb.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/watermelon_bomb.mp4"
  },
  {
    "scene": "wealth_drive",
    "label": "Wealth Drive",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "other",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/wealth_drive_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/wealth_drive.mp4"
  },
  {
    "scene": "wig_out",
    "label": "Wig Out",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/wig_out.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/wig_out.mp4"
  },
  {
    "scene": "winter_charm",
    "label": "Winter Charm",
    "units": 1.7,
    "priceUsd": 0.238,
    "type": "single",
    "category": "holiday",
    "coverUrl": "https://s15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/winter_charm_cover.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/winter_charm.mp4"
  },
  {
    "scene": "witch_transform",
    "label": "Witch Transform",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/witch_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/witch_transform.mp4"
  },
  {
    "scene": "woodland_elf",
    "label": "Woodland Elf",
    "units": 3.5,
    "priceUsd": 0.49,
    "type": "single",
    "category": "fantasy",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/woodland_elf.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/woodland_elf.mp4"
  },
  {
    "scene": "wool_curly",
    "label": "Wool Curly",
    "units": 1,
    "priceUsd": 0.14,
    "type": "single",
    "category": "transform",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/wool_curly.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/wool_curly.mp4"
  },
  {
    "scene": "yangge_dance",
    "label": "Yangge Dance",
    "units": 5,
    "priceUsd": 0.7,
    "type": "single",
    "category": "lunar_new_year",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/yangge_dance.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/yangge_dance.mp4"
  },
  {
    "scene": "yearbook",
    "label": "Yearbook",
    "units": 2,
    "priceUsd": 0.28,
    "type": "single",
    "category": "photo_style",
    "coverUrl": "https://d21-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_pic_compress/yearbook.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/yearbook.mp4"
  },
  {
    "scene": "zombie_transform",
    "label": "Zombie Transform",
    "units": 3,
    "priceUsd": 0.42,
    "type": "single",
    "category": "halloween",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover_update/zombie_transform.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/zombie_transform.mp4"
  },
  {
    "scene": "zoom_out",
    "label": "Zoom Out",
    "units": 1.5,
    "priceUsd": 0.21,
    "type": "single",
    "category": "other",
    "coverUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_cover/zoom_out.png",
    "previewUrl": "https://v15-kling.klingai.com/kos/s101/nlav112372/kling-op/effects_video/zoom_out.mp4"
  }
];
